export * from './left.component';
export * from './left-main-data';



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/left/index.ts